<script lang="ts">
	import {uqn} from './stores';
	import Katex from './Katex.svelte';
	import numberWithCommas from './functions/numberWithCommas';
	import nCr from './functions/nCr';
	import factorial from './functions/factorial';

	let a: string, b: string, c: string;
	$: a = partAGenerator($uqn);
	$: b = partBGenerator($uqn);
	$: c = partCGenerator($uqn);

	function partAGenerator(u:number):string{
		let type: number, biggest: number, compare:number, choices: number;
		type = Number(u.toString()[0]);
		biggest = Number(u.toString()[1]);
		compare = Number(u.toString()[2]);
		choices = Number(u.toString()[3]);
		if (type==1){
			return (biggest-compare+1).toString() + "\\times " + (biggest-1).toString() + "!=" + numberWithCommas((biggest-compare+1)*factorial(biggest-1));
		} else if (type==2){
			return (choices-compare+1).toString() + "\\times {" + (choices-1).toString() +  "\\choose " + (biggest-1).toString() + "}\\times " + (biggest-1).toString() + "!=" + numberWithCommas((choices-compare+1)*nCr(choices-1,biggest-1)*factorial(biggest-1));
		} else {
			return (choices-compare+1).toString() + "\\times " + choices.toString() + "^" + (biggest-1).toString() + "=" + numberWithCommas((choices-compare+1)*Math.pow(choices,biggest-1));
		}
	}

	function partBGenerator(u:number):string{
		let type: number, biggest: number, choices: number;
		type = Number(u.toString()[0]);
		biggest = Number(u.toString()[1]);
		choices = Number(u.toString()[3]);
		let evens: number, total: number;
		if (type==1){
			total = biggest;
		} else{
			total = choices;
		}
		evens = Math.floor(total/2);

		if (type==3){
			return evens.toString() + "^2 \\times" + choices.toString() + "^" + (biggest-2).toString() + "=" + numberWithCommas(evens*evens*Math.pow(choices,biggest-2));
		} else {
			let ansString = "{" + evens.toString() + "\\choose 2}\\times 2! \\times";
			let extraTerm = 1;
			if (type==2){
				ansString += "{" + (choices-2).toString() + "\\choose " + (biggest-2).toString() + "}\\times ";
				extraTerm = nCr(choices-2,biggest-2);
			}
			return ansString + (biggest-2).toString() + "!=" + numberWithCommas(nCr(evens,2)*2*extraTerm*factorial(biggest-2));
		}
	}

	function partCGenerator(u:number):string{
		let type: number, biggest: number, compare:number, choices: number;
		type = Number(u.toString()[0]);
		biggest = Number(u.toString()[1]);
		compare = Number(u.toString()[2]);
		choices = Number(u.toString()[3]);
		if (type==3){
			return (choices-compare+1).toString() + "\\times " + (choices).toString() + "^" + (biggest-2).toString() + "\\times " + Math.ceil(choices/2).toString() + "=" + numberWithCommas((choices-compare+1)*Math.ceil(choices/2)*Math.pow(choices,biggest-2));
		} else if (type==2){
			const firstNumberChoicesTotal = choices-compare+1;
			let evens: number, odds: number;
			if (compare%2==0) { // start even
				evens = Math.ceil(firstNumberChoicesTotal/2);
				odds = Math.floor(firstNumberChoicesTotal/2)
			} else{ // start odd
				evens = Math.floor(firstNumberChoicesTotal/2);
				odds = Math.ceil(firstNumberChoicesTotal/2)
			}
			const oddEnds = Math.ceil(choices/2);
			const caseEvenString = evens.toString() + "\\times " + oddEnds.toString() + "\\times {" + (choices-2).toString() + "\\choose " + (biggest-2).toString() + "} \\times "
			+ (biggest-2).toString() + "!+";
			const caseOddString = odds.toString() + "\\times " + (oddEnds-1).toString() + "\\times {" + (choices-2).toString() + "\\choose " + (biggest-2).toString() + "} \\times "
			+ (biggest-2).toString() + "!=";
			const answerNumber = (evens*oddEnds + odds*(oddEnds-1) )*nCr(choices-2,biggest-2)*factorial(biggest-2);
			return caseEvenString + caseOddString + numberWithCommas(answerNumber);
		} else {
			const firstNumberChoicesTotal = biggest-compare+1;
			let evens: number, odds: number;
			if (compare%2==0) { // start even
				evens = Math.ceil(firstNumberChoicesTotal/2);
				odds = Math.floor(firstNumberChoicesTotal/2)
			} else{ // start odd
				evens = Math.floor(firstNumberChoicesTotal/2);
				odds = Math.ceil(firstNumberChoicesTotal/2)
			}
			const oddEnds = Math.ceil(biggest/2);
			const caseEvenString = evens.toString() + "\\times " + oddEnds.toString() + " \\times "	+ (biggest-2).toString() + "!+";
			const caseOddString = odds.toString() + "\\times " + (oddEnds-1).toString() + "\\times " + (biggest-2).toString() + "!=";
			const answerNumber = (evens*oddEnds + odds*(oddEnds-1) )*factorial(biggest-2);
			return caseEvenString + caseOddString + numberWithCommas(answerNumber);
		}
	}
</script>

<div>
	<p>(a) <Katex math={a}/> </p>
	<p>(b) <Katex math={b}/> </p>
	<p>(c) <Katex math={c}/> </p>
</div>